import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  Grid,
  FormControl,
  FormLabel,
} from '@material-ui/core';
import Icon from '@mdi/react';
import {mdiAccountCircle} from '@mdi/js';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(3),
      textAlign: 'left',
    },
    button: {
      color: 'red',
      borderColor: 'red',
    },
    buttons: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      alignContent: 'center',
      width: '100%',
      height: '100%',
    },
    exit: {
      textAlign: 'center',
      width: '100%',
      height: '100%',
      alignItems: 'center',
    },
  })
);

const Exit = (props: any) => {
  const classes = useStyles();
  return (
    <Dialog
      open={props.openExitModal}
      onClose={props.closeExitHandler}
      aria-labelledby="responsive-dialog-title"
      fullScreen
      className={classes.exit}
    >
      <DialogActions className={classes.buttons}>
        <Grid>
          <Grid>
            <Icon path={mdiAccountCircle} size={3} />
          </Grid>
          <Grid>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel
                component="legend"
                style={{color: 'black', margin: '0 0 30px 0'}}
              >
                {/* {'احمد احمدی'} */}
              </FormLabel>
            </FormControl>
          </Grid>
          <Grid spacing={5}>
            <Button
              onClick={props.closeExitHandler}
              variant="outlined"
              color="primary"
            >
              {'بازگشت'}
            </Button>
            &nbsp; &nbsp; &nbsp; &nbsp;
            <Button
              onClick={props.exitHandler}
              variant="outlined"
              className={classes.button}
            >
              {'خروج از حساب کاربری'}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default Exit;
